import React, { useState, Fragment } from 'react'

import PropTypes from 'prop-types'

import './fa-qs.css'

const FAQs = (props) => {
  const [faq1Visible, setFaq1Visible] = useState(false)
  const [faq4Visible, setFaq4Visible] = useState(false)
  const [faq3Visible, setFaq3Visible] = useState(false)
  const [faq2Visible, setFaq2Visible] = useState(false)
  return (
    <div className={`fa-qs-faq8 thq-section-padding ${props.rootClassName} `}>
      <div className="fa-qs-max-width thq-section-max-width">
        <div className="fa-qs-container10 thq-flex-column">
          <div className="fa-qs-list thq-flex-column">
            <div className="fa-qs-faq1">
              <div
                onClick={() => setFaq1Visible(!faq1Visible)}
                className="fa-qs-trigger1"
              >
                <p className="fa-qs-faq1-question thq-body-large">
                  {props.faq1Question ?? (
                    <Fragment>
                      <span className="fa-qs-text35">
                        How to Charge Your Vehicle Using iCharge
                      </span>
                    </Fragment>
                  )}
                </p>
                <div className="fa-qs-icons-container1">
                  {faq1Visible === false && (
                    <div>
                      <svg viewBox="0 0 1024 1024" className="fa-qs-icon10">
                        <path d="M316 366l196 196 196-196 60 60-256 256-256-256z"></path>
                      </svg>
                    </div>
                  )}
                  {faq1Visible === true && (
                    <div>
                      <svg viewBox="0 0 1024 1024" className="fa-qs-icon12">
                        <path d="M316 658l-60-60 256-256 256 256-60 60-196-196z"></path>
                      </svg>
                    </div>
                  )}
                </div>
              </div>
              {faq1Visible === true && (
                <div className="fa-qs-container13">
                  <ul className="fa-qs-ul1 list">
                    <li className="list-item">
                      <span className="navbar-font">
                        Download the iCharge App: Install the iCharge
                        application from the App Store or Google Play.
                      </span>
                    </li>
                    <li className="list-item">
                      <span className="navbar-font">
                        Create an Account: Register by providing your email and
                        payment information.
                      </span>
                    </li>
                    <li className="list-item">
                      <span className="navbar-font">
                        <span>
                          Locate a Charging Station: Use the app&apos;s map
                          feature to find nearby charging stations.
                        </span>
                        <br></br>
                      </span>
                    </li>
                    {props.faq1ListItems >= 4 && (
                      <li className="list-item navbar-font">
                        <span className="navbar-font">
                          Start Charging: Once at a station, scan the QR code on
                          the charger using the app to initiate the charging
                          session.
                        </span>
                      </li>
                    )}
                    {props.faq1ListItems >= 5 && (
                      <li className="list-item navbar-font">
                        <span className="navbar-font">
                          Monitor and Pay: Track your charging progress in
                          real-time and pay for the session using your saved
                          payment method
                        </span>
                      </li>
                    )}
                  </ul>
                </div>
              )}
            </div>
            <div className="fa-qs-faq2">
              <div
                onClick={() => setFaq2Visible(!faq2Visible)}
                className="fa-qs-trigger2"
              >
                <p className="fa-qs-faq2-question navbar-font">
                  {props.faq2Question ?? (
                    <Fragment>
                      <span className="fa-qs-text34">
                        How to Top Up Your Balance
                      </span>
                    </Fragment>
                  )}
                </p>
                <div className="fa-qs-icons-container2">
                  {faq2Visible === false && (
                    <div>
                      <svg viewBox="0 0 1024 1024" className="fa-qs-icon14">
                        <path d="M316 366l196 196 196-196 60 60-256 256-256-256z"></path>
                      </svg>
                    </div>
                  )}
                  {faq2Visible === true && (
                    <div>
                      <svg viewBox="0 0 1024 1024" className="fa-qs-icon16">
                        <path d="M316 658l-60-60 256-256 256 256-60 60-196-196z"></path>
                      </svg>
                    </div>
                  )}
                </div>
              </div>
              {faq2Visible === true && (
                <div className="fa-qs-container16">
                  <ul className="fa-qs-ul2 list">
                    <li className="list-item">
                      <span className="navbar-font">
                        <span className="fa-qs-text18">
                          Access Payment Settings
                        </span>
                        <span>
                          : Open the app and go to the &apos;Profile&apos;
                          section.
                        </span>
                      </span>
                    </li>
                    <li className="list-item">
                      <span className="navbar-font">
                        <span className="fa-qs-text21">Add Payment Method</span>
                        <span>
                          : Select &apos;Payment Method&apos; and choose between
                          <span
                            dangerouslySetInnerHTML={{
                              __html: ' ',
                            }}
                          />
                        </span>
                      </span>
                      <ul className="fa-qs-ul3 list">
                        <li className="list-item">
                          <span>Pay Cash</span>
                        </li>
                        <li className="list-item">
                          <span>
                            <span>Pay Card</span>
                            <span>
                              <span
                                dangerouslySetInnerHTML={{
                                  __html: ' ',
                                }}
                              />
                            </span>
                          </span>
                        </li>
                      </ul>
                    </li>
                    <li className="list-item">
                      <span className="navbar-font">
                        <span className="fa-qs-text28">
                          Enter your credit or debit card
                        </span>
                        <span>
                          {' '}
                          details,or show the qr code to the Western Union
                          Office
                        </span>
                      </span>
                    </li>
                    <li className="list-item">
                      <span className="navbar-font">
                        <span className="fa-qs-text31">Top Up</span>
                        <span>
                          : Follow the prompts to add funds to your account.
                        </span>
                      </span>
                    </li>
                  </ul>
                </div>
              )}
            </div>
            <div className="fa-qs-faq3">
              <div
                onClick={() => setFaq3Visible(!faq3Visible)}
                className="fa-qs-trigger3"
              >
                <p className="fa-qs-faq3-question navbar-font">
                  {props.faq3Question ?? (
                    <Fragment>
                      <span className="fa-qs-text36">
                        Is iCharge Available Internationally?
                      </span>
                    </Fragment>
                  )}
                </p>
                <div className="fa-qs-icons-container3">
                  {faq3Visible === false && (
                    <div className="navbar-font">
                      <svg viewBox="0 0 1024 1024" className="fa-qs-icon18">
                        <path d="M316 366l196 196 196-196 60 60-256 256-256-256z"></path>
                      </svg>
                    </div>
                  )}
                  {faq3Visible === true && (
                    <div className="navbar-font">
                      <svg viewBox="0 0 1024 1024" className="fa-qs-icon20">
                        <path d="M316 658l-60-60 256-256 256 256-60 60-196-196z"></path>
                      </svg>
                    </div>
                  )}
                </div>
              </div>
              {faq3Visible === true && (
                <div className="fa-qs-container19">
                  <span className="fa-qs-faq3-answer navbar-font">
                    {props.faq3Answer ?? (
                      <Fragment>
                        <span className="fa-qs-text33">
                          With iCharge Roaming, you can now see where you can
                          charge your vehicle across Europe. Always check the
                          app for available stations in your area before
                          traveling dy here.
                        </span>
                      </Fragment>
                    )}
                  </span>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

FAQs.defaultProps = {
  rootClassName: '',
  faq3Answer: undefined,
  faq1ListItems: 3,
  faq2Question: undefined,
  faq1Question: undefined,
  faq3Question: undefined,
}

FAQs.propTypes = {
  rootClassName: PropTypes.string,
  faq3Answer: PropTypes.element,
  faq1ListItems: PropTypes.number,
  faq2Question: PropTypes.element,
  faq1Question: PropTypes.element,
  faq3Question: PropTypes.element,
}

export default FAQs
